import { render } from "./FinishPage.vue?vue&type=template&id=5c34cec9&scoped=true"
import script from "./FinishPage.vue?vue&type=script&lang=js"
export * from "./FinishPage.vue?vue&type=script&lang=js"

import "./FinishPage.vue?vue&type=style&index=0&id=5c34cec9&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c34cec9"]])

export default __exports__